import { isAfter as isAfterFns } from 'date-fns';

export default function isAfter(date: Date, dateToCompareTo: Date): boolean {
  return isAfterFns(date, dateToCompareTo);
}
